module.exports = __webpack_public_path__ + "img/RapidExperimentingWithJobShadow_new_logo.5ed51c97.png";